import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { SearchesModel } from '../../models/platform/searchesModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class USPTOApi {

    async getApplications(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/uspto/application`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getApplicationDetail(search_execution_id: string, application_country: string, application_doc_number: string, application_date: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                application_country,
                application_doc_number,
                application_date,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post( `${API_URL}/api/data-sections/uspto/application/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getAssignments(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/uspto/assignment`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getAssignmentDetail(search_execution_id: string, frame_no: string, reel_no: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                frame_no,
                reel_no,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post( `${API_URL}/api/data-sections/uspto/assignment/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getGrants(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/uspto/grant`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }
    
    async getGrantDetail(search_execution_id: string, publication_country: string, publication_doc_number: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                publication_country,
                publication_doc_number,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post( `${API_URL}/api/data-sections/uspto/grant/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

}

const usptoApi = new USPTOApi();
export default usptoApi;
